
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("dy9lH", function(module, exports) {

$parcel$export(module.exports, "register", () => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf, (v) => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $9dd5b3e06d7b5702$export$f7ad0328861e2f03, (v) => $9dd5b3e06d7b5702$export$f7ad0328861e2f03 = v);
var $9dd5b3e06d7b5702$export$6503ec6e8aabbaf;
var $9dd5b3e06d7b5702$export$f7ad0328861e2f03;
"use strict";
var $9dd5b3e06d7b5702$var$mapping = new Map();
function $9dd5b3e06d7b5702$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$9dd5b3e06d7b5702$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $9dd5b3e06d7b5702$var$resolve(id) {
    var resolved = $9dd5b3e06d7b5702$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$9dd5b3e06d7b5702$export$6503ec6e8aabbaf = $9dd5b3e06d7b5702$var$register;
$9dd5b3e06d7b5702$export$f7ad0328861e2f03 = $9dd5b3e06d7b5702$var$resolve;

});

var $24d0d885d8af30c4$exports = {};

(parcelRequire("dy9lH")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"bYT2S\",\"shared~atlassian-navigation~atlaskit~ar.d4099a26.js\",\"27oU7\",\"@atlaskit-internal_atlassian-custom-theme.c0433523.js\",\"gEQHL\",\"atlassian-light.502e85ff.js\",\"bPJN2\",\"atlassian-light-future.81777d1c.js\",\"hl8lH\",\"atlassian-light-increased-contrast.8aba4d58.js\",\"daAG3\",\"atlassian-dark.bbb0e374.js\",\"bXEKJ\",\"atlassian-dark-future.1bf64634.js\",\"cNb6z\",\"atlassian-dark-increased-contrast.77490bb0.js\",\"jg28y\",\"atlassian-legacy-light.dde2217b.js\",\"8i4lj\",\"@atlaskit-internal_atlassian-dark-future.141e71f5.js\",\"hXkhg\",\"atlassian-spacing.92217b6b.js\",\"5z019\",\"atlassian-typography-adg3.b7dc470a.js\",\"hCyxS\",\"atlassian-shape.8dfc4c74.js\",\"d9485\",\"atlassian-typography-modernized.3e8f7f69.js\",\"6fbhv\",\"@atlaskit-internal_atlassian-typography-adg3.acf934c5.js\",\"7Tj3m\",\"@atlaskit-internal_atlassian-shape.11431ce1.js\",\"fzIYN\",\"@atlaskit-internal_atlassian-typography-modernized.f17fea45.js\"]"));


$parcel$global.rlb("h2MrD")
//# sourceMappingURL=shared~atlassian-navigation~atlaskit~ar.runtime.e80eb95d.js.map
